import { Spacer, Text } from '@cellula/react';
import { withTranslation } from '../../with_translation';
import { tokens } from '@cellula/react-theme-patient';
import { QRCodeSVG } from 'qrcode.react';
import { useResolve } from '@visiba/instantiation';
import { KioskSessionFlow, SessionController } from '../../session.controller';

interface Props {
	flow: KioskSessionFlow;
}

export function QrHook({ flow = KioskSessionFlow.Vcs }: Props): JSX.Element {
	const controller = useResolve(SessionController);

	return (
		<div style={{ textAlign: 'center' }}>
			<Spacer vertical={tokens.spacing.x4} />
			<QRCodeSVG
				size={256}
				value={`${location.origin}/${controller.languageCode}-${controller.countryCode}${flow === KioskSessionFlow.Vcs ? '' : '/emg'}`}
				fgColor='#192851'
				level='Q'
				imageSettings={{ src: '/qr_logo.png', height: 80, width: 80, excavate: false }}
			/>
			<Spacer vertical={tokens.spacing.x4} />
			<Text.h1 variant='headingMedium'>{withTranslation('qr-hook.title')}</Text.h1>
			<Spacer vertical={tokens.spacing.x4} />
			<Text.p variant='bodyRegular'>{withTranslation('qr-hook.description')}</Text.p>
		</div>
	);
}
